export default __webpack_public_path__ + "static/5-3c5d3fecc64677e896b0b2ad8fc571cb.webp";